import styled from 'styled-components';

export const TitlesContainer = styled.div`
  margin-left: 20px;
  margin-bottom: 30px;

  & h2 {
    margin-top: 5px;
    margin-bottom: 10px;
  }

  & p {
    color: var(--TextSecondary);
    margin: 0;
  }
`;
